import { render, staticRenderFns } from "./wax-type-add.vue?vue&type=template&id=4a4dcbff&"
import script from "./wax-type-add.vue?vue&type=script&lang=js&"
export * from "./wax-type-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a4dcbff')) {
      api.createRecord('4a4dcbff', component.options)
    } else {
      api.reload('4a4dcbff', component.options)
    }
    module.hot.accept("./wax-type-add.vue?vue&type=template&id=4a4dcbff&", function () {
      api.rerender('4a4dcbff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/production-manage/wax-type/wax-type-add.vue"
export default component.exports